module.exports = __webpack_public_path__ + "img/9.2c166044.jpg";